import { memo } from "react";

import { Text } from "@react/components/Text";
import { type ModelMeasurementDetails } from "@tablescape/state";
import { tw } from "classnames";

const styles = {
  heading: tw(
    "mt-6",
    "mb-4",
    "pb-4",
    "border-0",
    "border-b",
    "border-solid",
    "border-primary"
  ),
  content: tw("mb-2"),
  tableRow: tw("flex", "flex-row", "mb-px"),
  tableHeaderCell: tw("capitalize", "w-20"),
};

const ModelDetailsBase = ({
  content,
  heading,
  table,
}: ModelMeasurementDetails) => {
  return (
    <>
      <div className={styles.heading}>
        <Text as="title2" size="xs">
          {heading}
        </Text>
      </div>
      <Text as="body2" className={styles.content}>
        {content}
      </Text>
      {table.map((row: string[]) => {
        return (
          <div className={styles.tableRow} key={row[0]}>
            <Text as="body2" className={styles.tableHeaderCell}>
              {row[0]}
            </Text>
            <Text as="body2">{row[1]}</Text>
          </div>
        );
      })}
    </>
  );
};

export const ModelDetails = memo(ModelDetailsBase);
